import { createAsyncThunk } from '@reduxjs/toolkit';
import api from 'api';
import { Comment } from 'store/comments/interfaces/Comment';

export interface CreatePDPCommentRequest {
  content: string;
}

export const createPDPComment = createAsyncThunk<
  Comment,
  { threadId: number; data: CreatePDPCommentRequest }
>('pdp/createPDPComment', async ({ threadId, data }, { rejectWithValue }) =>
  api.axios
    .post(`/api/comment/thread/${threadId}/comment`, data)
    .then((res) => res.data)
    .catch((e) => rejectWithValue(e.response?.data)),
);
